<template lang="pug">
.curso-main-container.pb-3
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5.mb-5
    .titulo-principal.color-acento-contenido(data-aos="flip-up")
      .titulo-principal__numero
        span 5
      h1 Relaciones interpersonales y convivencia

    .row.align-items-center
      .col-lg-8
        p Las relaciones interpersonales hacen referencia a las interacciones que se establecen entre las personas en diferentes contextos de la vida cotidiana, como el entorno familiar, social, educativo y laboral. Estas relaciones se construyen a partir del intercambio de ideas, emociones, experiencias y comportamientos que permiten a los individuos relacionarse y colaborar entre sí. La calidad de las relaciones interpersonales influye directamente en la convivencia, ya que a través de ellas se desarrollan valores como el respeto, la empatía, la cooperación y la responsabilidad compartida.

        .row.justify-content-center
          .col-lg-12
            .row.align-items-center
              .col-lg-12
                .cajon.color2.p-4
                  p En los espacios de convivencia, las relaciones interpersonales juegan un papel fundamental en la construcción de ambientes armoniosos y participativos. Cuando las personas mantienen una comunicación clara, respetan las diferencias y muestran disposición para escuchar a los demás, es más fácil establecer relaciones basadas en la confianza y la comprensión. Por el contrario, la falta de diálogo, el irrespeto o la dificultad para gestionar los conflictos pueden afectar negativamente la convivencia y generar tensiones en los grupos sociales.
    
      .col-lg-4.d-none.d-lg-block
        figure
          img(src='@/assets/curso/tema5/1.png', alt='', style="width: 390px").m-auto


    .row.align-items-center.justify-content-center
      .col-lg-12
        .row.justify-content-center.mt-4
          .col-lg-12(data-aos="fade-down")
            .row.d-flex.align-items-center.bg-base(data-aos="fade-right")
              .col-lg-auto.pe-lg-0.mb-4.mb-xl-0.d-flex.d-none.d-lg-block
                figure.m-0.p-0.w-100.h-100.d-flex
                  img(src='@/assets/curso/tema5/3.png', alt='', class="w-100 h-100 object-fit-cover", style="margin-left:-12px")
              .col-lg
                figure
                  img(src="@/assets/curso/tema5/2.svg", alt="", style="width: 80px")

                p.mt-4.text-white Por esta razón, fortalecer las relaciones interpersonales implica desarrollar habilidades sociales que permitan interactuar de manera positiva con otras personas. Entre estas habilidades se encuentran la comunicación asertiva, la empatía, el trabajo en equipo y la capacidad para resolver desacuerdos de forma constructiva. De esta manera, las relaciones interpersonales se convierten en un elemento esencial para promover la convivencia, el bienestar colectivo y el desarrollo de competencias blandas necesarias para la vida personal y el desempeño en diferentes contextos sociales y laborales.



    p.mt-4 Para comprender mejor cómo se fortalecen las relaciones interpersonales y la convivencia, en la tabla 6 se pueden identificar algunos elementos que influyen en la forma en que las personas interactúan entre sí. Las relaciones positivas se construyen a partir de actitudes, habilidades y valores que favorecen la comunicación, el respeto y la cooperación. En la siguiente tabla se presentan algunos factores que contribuyen al fortalecimiento de las relaciones interpersonales y su importancia en la convivencia dentro de los diferentes contextos sociales y laborales.

    .row.justify-content-center.mt-4
      .col-lg-10
        .titulo-sexto.color-acento-contenido.mb-3.mt-4
          h5 Tabla 6.
          span Factores que fortalecen las relaciones interpersonales y la convivencia

        .tabla-a.color-acento-contenido
          table
            thead(style="background-color: #A0F7FE")
              tr
                th(style="width: 300px;") Factor
                th Descripción
                th Importancia en la convivencia
            tbody
              tr(style="background-color: #F6F6F6")
                td.text-start #[b Respeto]
                td.text-start Reconocimiento del valor y la dignidad de las demás personas, aceptando sus opiniones y diferencias.
                td.text-start Permite construir relaciones basadas en la confianza y la consideración mutua.
              tr
                td.text-start #[b Empatía]
                td.text-start Capacidad para comprender las emociones y perspectivas de otras personas.
                td.text-start Favorece la comprensión y fortalece la calidad de las relaciones interpersonales.

              tr(style="background-color: #F6F6F6")
                td.text-start #[b Comunicación efectiva]
                td.text-start Expresión clara de ideas y sentimientos acompañada de escucha activa.
                td.text-start Facilita el entendimiento entre las personas y previene malentendidos.
              tr
                td.text-start #[b Trabajo en equipo]
                td.text-start Disposición para colaborar con otras personas en el logro de objetivos comunes.
                td.text-start Promueve la cooperación, la responsabilidad compartida y el apoyo mutuo.

              tr(style="background-color: #F6F6F6")
                td.text-start #[b Resolución de conflictos]
                td.text-start Capacidad para abordar desacuerdos mediante el diálogo y la búsqueda de soluciones constructivas.
                td.text-start Contribuye a mantener ambientes de convivencia armoniosos y productivos.

    separador
    #t_5_1.titulo-segundo.color-acento-contenido
      h2 5.1 Importancia de las relaciones interpersonales

    .row.align-items-center
      .col-lg-5.d-none.d-lg-block
        figure
          img(src='@/assets/curso/tema5/4.png', alt='', style="width: 480px").m-auto
      .col-lg-7
        .row.justify-content-center
          .col-lg-12
            .row.align-items-center
              .col-lg-12
                .cajon.color1.p-4
                  p Las relaciones interpersonales son fundamentales para el desarrollo humano, ya que permiten a las personas interactuar, compartir experiencias y construir vínculos con otros en diferentes contextos de la vida cotidiana. A través de estas relaciones se desarrollan habilidades sociales que facilitan la comunicación, la cooperación y el entendimiento mutuo. La calidad de las relaciones que se establecen con otras personas influye directamente en el bienestar emocional, la convivencia y el desarrollo personal.

        .row.align-items-start.mt-4
          .col-lg-2.mb-lg-0.mb-4
            figure(data-aos="fade-down")
              img(src='@/assets/curso/tema5/5.svg', style='width: 100px').m-auto
          
          .col
            p Estos vínculos se manifiestan en dos contextos fundamentales que determinan su impacto en la vida de las personas. A continuación, se presenta la manera en que influyen en cada uno de estos espacios:


    TabsC.color-acento-botones.mt-4
      .py-3.py-md-4.bg-base4(titulo="En el ámbito social")
        .row.p-4
          .col-md-4
            figure
              img(src='@/assets/curso/tema5/6.png', alt='', style="width: 390px").m-auto
          .col-md-8.mb-4.mb-md-0
            p Espacio de interacción en el que las personas construyen vínculos basados en valores compartidos, el respeto mutuo y la solidaridad, contribuyendo al bienestar colectivo de las comunidades:

            ul.lista-ul--color
              li
                i.lista-ul__vineta
                p.mb-0 Los vínculos sociales favorecen la construcción de comunidades basadas en el respeto, la solidaridad y la colaboración.
              li
                i.lista-ul__vineta
                p.mb-0 Cuando las personas se relacionan de manera positiva, se generan espacios de confianza que permiten el intercambio de ideas y la resolución de problemas.
              li
                i.lista-ul__vineta
                p.mb-0 Las interacciones sociales contribuyen a fortalecer los valores colectivos y promueven la convivencia pacífica entre los miembros de una comunidad.

              li
                i.lista-ul__vineta
                p.mb-0 La construcción de acuerdos y el reconocimiento de las diferencias fortalecen el tejido social y favorecen el bienestar colectivo.


    
      .py-3.py-md-4.bg-base4(titulo="En el contexto laboral")
        .row.p-4
          .col-md-4
            figure
              img(src='@/assets/curso/tema5/7.png', alt='', style="width: 390px").m-auto
          .col-md-8.mb-4.mb-md-0
            p Entorno en el que las personas establecen vínculos orientados al logro de objetivos comunes, donde la comunicación efectiva, el trabajo en equipo y el respeto mutuo son determinantes para el desempeño y la productividad:


            ul.lista-ul--color
              li
                i.lista-ul__vineta
                p.mb-0 Los vínculos laborales cumplen un papel esencial en el desempeño de las personas y en el funcionamiento de las organizaciones.

              li
                i.lista-ul__vineta
                p.mb-0 La capacidad de trabajar en equipo, comunicarse de manera efectiva y mantener relaciones respetuosas influye en el logro de objetivos y en la productividad de los grupos de trabajo.

              li
                i.lista-ul__vineta
                p.mb-0 Las organizaciones valoran cada vez más las habilidades de interacción, ya que contribuyen a mejorar el clima laboral y a fortalecer la cooperación entre los integrantes de un equipo.

              li
                i.lista-ul__vineta
                p.mb-0 El desarrollo de relaciones laborales positivas favorece la motivación, el compromiso y el desempeño efectivo de las personas en sus responsabilidades.


    .row.justify-content-center.mt-4
      .col-lg-10
        .row.align-items-center
          .col-lg-12
            .cajon.color3.p-4
              p Construir vínculos positivos implica fortalecer competencias como la empatía, la comunicación asertiva, el respeto por las diferencias y la capacidad para resolver conflictos de manera constructiva.


    p.mt-4 Estas habilidades permiten interactuar de forma adecuada con otras personas y favorecen la creación de ambientes de convivencia armoniosos. En consecuencia, los vínculos humanos se convierten en un elemento clave para el crecimiento personal, el bienestar social y el desempeño efectivo en los diferentes ámbitos de la vida.



    separador
    #t_5_2.titulo-segundo.color-acento-contenido
      h2 5.2 Empatía y respeto en la interacción social


    p La empatía y el respeto son valores fundamentales para fortalecer la interacción social y promover relaciones interpersonales positivas. La empatía se refiere a la capacidad de comprender las emociones, pensamientos y experiencias de otras personas, poniéndose en su lugar para interpretar mejor sus sentimientos y perspectivas. Por su parte, el respeto implica reconocer el valor y la dignidad de cada individuo, aceptando sus ideas, creencias y diferencias. Estos dos elementos son esenciales para construir relaciones basadas en la comprensión, la tolerancia y la convivencia armónica.

    .bloque-texto-g.bloque-texto-g--inverso.bg-base.p-3.p-sm-4.p-md-5
      .bloque-texto-g__img(
        :style="{'background-image': `url(${require('@/assets/curso/tema5/8.png')})`}"
      )
      .bloque-texto-g__texto.p-4
        p.mb-0 En los espacios sociales, la empatía permite que las personas desarrollen una mayor sensibilidad frente a las situaciones que viven los demás. Cuando una persona es empática, procura escuchar con atención, comprender los sentimientos de otros y responder de manera considerada ante sus necesidades o preocupaciones. Esta capacidad favorece el fortalecimiento de la comunicación interpersonal y contribuye a reducir conflictos derivados de la falta de comprensión o del desconocimiento de las emociones ajenas.


    .row.justify-content-center.mt-4
      .col-lg-10
        .row.align-items-center
          .col-lg-12
            .cajon.color1.p-4
              p Asimismo, el respeto en la interacción social implica actuar de manera responsable y consciente frente a las diferencias que existen entre las personas. Cada individuo posee experiencias, opiniones y valores propios que deben ser reconocidos y valorados dentro de la convivencia. Practicar el respeto significa escuchar las ideas de los demás, evitar actitudes discriminatorias y promover un trato digno en todas las interacciones, tanto en contextos personales como sociales o laborales.


        p.mt-4 Desarrollar una interacción social empática requiere la práctica consciente de principios que orientan la manera en que las personas se relacionan con los demás. A continuación, se presentan los principios fundamentales que caracterizan una interacción social basada en la empatía y el respeto:

    .row.align-items-center.justify-content-center.mt-4
      .col-lg-12
        SlyderF(columnas="col-lg-6 col-xl-4")
          .tarjeta.bg-04.p-4.text-white
            .row.justify-content-center.mb-3
              .col-8
                img(src='@/assets/curso/tema5/9.svg', style="width: 128px").m-auto
            p.text-center
              b Escucha activa y sin juicios
            p.text-center.mb-0 Prestar atención plena a lo que la otra persona expresa, evitando interrupciones y suspendiendo los prejuicios para comprender su mensaje con objetividad y apertura.

          .tarjeta.bg-04.p-4.text-white
            .row.justify-content-center.mb-3
              .col-8
                img(src='@/assets/curso/tema5/10.svg', style="width: 128px").m-auto
            p.text-center
              b Reconocimiento de las emociones ajenas
            p.text-center.mb-0 Identificar y validar los sentimientos de otras personas, demostrando comprensión frente a sus experiencias sin minimizar su importancia o impacto emocional.

          .tarjeta.bg-04.p-4.text-white
            .row.justify-content-center.mb-3
              .col-8
                img(src='@/assets/curso/tema5/11.svg', style="width: 128px").m-auto
            p.text-center
              b Respeto por la diversidad
            p.text-center.mb-0 Aceptar y valorar las diferencias culturales, de pensamiento y de experiencia que caracterizan a cada individuo, reconociéndolas como un elemento enriquecedor de la convivencia.


          .tarjeta.bg-04.p-4.text-white
            .row.justify-content-center.mb-3
              .col-8
                img(src='@/assets/curso/tema5/12.svg', style="width: 128px").m-auto
            p.text-center
              b Comunicación respetuosa y asertiva
            p.text-center.mb-0 Expresar ideas y opiniones de manera clara y considerada, evitando actitudes agresivas o pasivas que puedan afectar la calidad de la interacción con los demás.


          .tarjeta.bg-04.p-4.text-white
            .row.justify-content-center.mb-3
              .col-8
                img(src='@/assets/curso/tema5/13.svg', style="width: 128px").m-auto
            p.text-center
              b Disposición al diálogo
            p.text-center.mb-0 Mantener una actitud abierta para construir acuerdos, resolver diferencias y buscar soluciones que favorezcan el bienestar de todas las personas involucradas en la interacción.


    p.mt-4 Por esta razón, el desarrollo de la empatía y el respeto contribuye a mejorar la calidad de los vínculos humanos y a fortalecer la convivencia en los distintos espacios de interacción. Cuando las personas practican estos valores de manera consciente, se crean ambientes de confianza, cooperación y diálogo que favorecen la resolución de conflictos y la construcción de acuerdos. De esta manera, la empatía y el respeto se consolidan como pilares fundamentales para la interacción social y el desarrollo de competencias blandas necesarias en la vida personal y profesional.


    separador
    #t_5_3.titulo-segundo.color-acento-contenido
      h2 5.3 Resolución de conflictos en contextos cotidianos


    p Los conflictos forman parte natural de las relaciones humanas y pueden surgir en diferentes contextos de la vida cotidiana, como en la familia, el entorno social, el ámbito educativo o el espacio laboral. Estos desacuerdos suelen aparecer cuando existen diferencias en opiniones, intereses, valores o percepciones entre las personas. Sin embargo, los conflictos no siempre tienen un impacto negativo, ya que, cuando se gestionan de manera adecuada, pueden convertirse en oportunidades para el aprendizaje, el diálogo y el fortalecimiento de las relaciones interpersonales.


    .row.align-items-center.mt-4
      .col-lg-4.d-none.d-lg-block
        figure
          img(src='@/assets/curso/tema5/14.svg', alt='', style="width: 390px").m-auto

      .col-lg-8
        .row.justify-content-center
          .col-lg-12
            .row.align-items-center
              .col-lg-12
                .cajon.color3.p-4
                  p En este sentido, la resolución de conflictos implica identificar las causas del desacuerdo, comprender las perspectivas de las personas involucradas y buscar soluciones que favorezcan el bienestar de todos. Este proceso requiere habilidades como la escucha activa, la empatía, la comunicación asertiva y la disposición para el diálogo. Cuando las personas están dispuestas a comprender el punto de vista de los demás y a expresar sus ideas con respeto, es posible encontrar alternativas que permitan superar las diferencias de manera constructiva.
        p.mt-4 Asimismo, la resolución de conflictos en contextos cotidianos exige mantener una actitud abierta y reflexiva frente a las situaciones que generan tensión o desacuerdo. Analizar el problema con calma, evitar reacciones impulsivas y buscar estrategias que permitan llegar a acuerdos basados en el respeto y la cooperación constituyen pasos fundamentales en este proceso. En muchos casos, escuchar con atención y reconocer las emociones de las otras personas contribuye de manera considerable a disminuir la intensidad del conflicto.

    p.mt-4 A continuación, se presentan las habilidades esenciales que orientan la resolución constructiva de conflictos en los diferentes contextos de la vida cotidiana:

    SlyderB.mb-5.mt-4.bg-base4.p-4(:datos="datosSlyder")

    .row.align-items-start.mt-4
      .col-lg-1.mb-lg-0.mb-4
        figure(data-aos="fade-down")
          img(src='@/assets/curso/tema5/22.svg', style='width: 100px').m-auto
      
      .col
        p En consecuencia, desarrollar estas habilidades permite fortalecer la convivencia y mejorar la calidad de los vínculos en diferentes espacios de interacción. Las personas que aprenden a gestionar los conflictos de manera adecuada pueden transformar situaciones de desacuerdo en oportunidades para el crecimiento personal y colectivo. De esta manera, la resolución constructiva de conflictos se convierte en una herramienta clave para promover el diálogo, la cooperación y el respeto en los distintos ámbitos de la vida social y laboral.


    separador
    #t_5_4.titulo-segundo.color-acento-contenido
      h2 5.4 Convivencia y trabajo colaborativo

    .row.align-items-center
      .col-lg-5.d-none.d-lg-block
        figure
          img(src='@/assets/curso/tema5/23.png', alt='', style="width: 480px").m-auto
      .col-lg-7
        p La convivencia se refiere a la capacidad de las personas para interactuar y compartir espacios con otros de manera respetuosa, solidaria y responsable. En los diferentes contextos sociales y laborales, convivir implica reconocer las diferencias individuales, aceptar distintos puntos de vista y mantener actitudes que favorezcan el respeto mutuo. Una convivencia positiva permite crear ambientes de confianza y cooperación donde las personas pueden desarrollar sus capacidades y contribuir al bienestar colectivo.

        p En este contexto, el trabajo colaborativo surge como una forma de interacción en la que varias personas participan activamente para alcanzar objetivos comunes. A diferencia del trabajo individual, el trabajo colaborativo se basa en la cooperación, la comunicación y el intercambio de ideas entre los miembros de un grupo. Cada persona aporta sus conocimientos, habilidades y experiencias, lo que permite enriquecer el proceso de aprendizaje y mejorar la calidad de los resultados obtenidos.

    .row.justify-content-center
      .col-lg-10
        .row.align-items-center
          .col-lg-12
            .cajon.color1.p-4
              p Asimismo, el trabajo colaborativo requiere el desarrollo de habilidades sociales que faciliten la interacción entre los integrantes de un equipo. Entre estas habilidades se destacan la comunicación efectiva, la empatía, la responsabilidad compartida y la capacidad para resolver conflictos de manera constructiva. Cuando los miembros de un grupo logran coordinar sus esfuerzos y mantener una actitud de respeto y apoyo mutuo, se fortalece la convivencia y se promueve un ambiente de trabajo más productivo y armonioso.

        p.mt-4 Por esta razón, promover la convivencia y el trabajo colaborativo contribuye al desarrollo de competencias blandas esenciales para la vida personal y profesional. Estas competencias permiten a las personas adaptarse a diferentes contextos sociales, participar activamente en la solución de problemas y construir relaciones basadas en la cooperación y el respeto. De esta manera, la convivencia y el trabajo colaborativo se convierten en elementos fundamentales para fortalecer la interacción social y alcanzar metas compartidas en distintos ámbitos de la vida.


    .row.bg-01
      .col-12
        .p-5
          .row.align-items-center
            .col-lg-8
              p A continuación, se presentan algunos ejemplos de situaciones en las que se evidencia la convivencia y el trabajo colaborativo en diferentes contextos sociales, educativos y laborales:

              ol.lista-ol--cuadro
                li 
                  .lista-ol--cuadro__vineta
                    span.text-black 1
                  p.mb-0 Escuchar y respetar las ideas de los demás durante una reunión de trabajo o una actividad grupal.
          
                li 
                  .lista-ol--cuadro__vineta
                    span.text-black 2
                  p.mb-0 Participar activamente en la realización de tareas compartidas dentro de un equipo.
          
                li 
                  .lista-ol--cuadro__vineta
                    span.text-black 3
                  p.mb-0 Apoyar a los compañeros cuando enfrentan dificultades en el desarrollo de una actividad.

                li 
                  .lista-ol--cuadro__vineta
                    span.text-black 4
                  p.mb-0 Compartir conocimientos y experiencias para mejorar los resultados del trabajo en grupo.

                li 
                  .lista-ol--cuadro__vineta
                    span.text-black 5
                  p.mb-0 Asumir responsabilidades individuales que contribuyan al logro de objetivos comunes.

                li 
                  .lista-ol--cuadro__vineta
                    span.text-black 6
                  p.mb-0 Mantener una actitud de respeto frente a las diferencias de opinión dentro de un equipo.

                li 
                  .lista-ol--cuadro__vineta
                    span.text-black 7
                  p.mb-0 Buscar soluciones conjuntas cuando se presentan desacuerdos o conflictos en el grupo.

                li 
                  .lista-ol--cuadro__vineta
                    span.text-black 8
                  p.mb-0 Reconocer y valorar los aportes que realizan los demás integrantes del equipo.

                li 
                  .lista-ol--cuadro__vineta
                    span.text-black 9
                  p.mb-0 Cumplir con los compromisos adquiridos dentro de una actividad colaborativa.


                li 
                  .lista-ol--cuadro__vineta
                    span.text-black 10
                  p.mb-0 Promover un ambiente de confianza y cooperación entre los miembros del grupo. 


            .col-lg-4
              figure
                img(src='@/assets/curso/tema5/24.png', alt='', style="width: 390px").m-auto

    .row.justify-content-center.mt-4
      .col-lg-10
        .row.align-items-center
          .col-lg-12
            .cajon.color3.p-4
              p La convivencia y el trabajo colaborativo no son habilidades que se desarrollan de manera espontánea, sino competencias que se fortalecen progresivamente a través de la práctica, la reflexión y el compromiso con el bienestar colectivo. Cada interacción representa una oportunidad para aprender a escuchar, a ceder, a aportar y a construir junto a otros, reconociendo que los logros compartidos son más sólidos y significativos que los alcanzados de manera individual.



    p.mt-4 En consecuencia, fortalecer la convivencia y el trabajo colaborativo implica asumir una actitud consciente y responsable frente a las relaciones con los demás, reconociendo el valor de cada persona dentro del grupo. Las organizaciones, las comunidades y los entornos educativos que promueven estos valores generan espacios de crecimiento colectivo donde las personas pueden desarrollar su potencial, construir vínculos sólidos y contribuir activamente a la construcción de una sociedad más justa, solidaria y participativa.




</template>

<script>
export default {
  name: 'Tema5',
  data: () => ({
    datosSlyder: [
      {
        titulo: 'La escucha activa',
        texto:
          'Prestar atención plena a las perspectivas de las personas involucradas en el conflicto, sin interrupciones ni prejuicios, facilita la comprensión mutua y abre espacios para el diálogo constructivo.',
        imagen: require('@/assets/curso/tema5/15.png'),
        // leyendaImagen: 'Leyenda de la imagen',
      },
      {
        titulo: 'La empatía',
        texto:
          'Comprender las emociones y el punto de vista de la otra persona permite abordar el conflicto desde una perspectiva más humana y encontrar soluciones que consideren el bienestar de todos los involucrados.',
        imagen: require('@/assets/curso/tema5/16.png'),
        // leyendaImagen: 'Leyenda de la imagen',
      },
      {
        titulo: 'La comunicación asertiva',
        texto:
          'Expresar los desacuerdos de manera clara, directa y respetuosa contribuye a evitar malentendidos y favorece la construcción de acuerdos basados en el respeto mutuo.',
        imagen: require('@/assets/curso/tema5/15.png'),
        // leyendaImagen: 'Leyenda de la imagen',
      },
      {
        titulo: 'El autocontrol emocional',
        texto:
          'Mantener la calma frente a situaciones de tensión permite analizar el problema con mayor objetividad y responder de manera reflexiva en lugar de reaccionar de forma impulsiva.',
        imagen: require('@/assets/curso/tema5/17.png'),
        // leyendaImagen: 'Leyenda de la imagen',
      },
      {
        titulo: 'La disposición al diálogo',
        texto:
          'Asumir una actitud abierta para escuchar, negociar y buscar soluciones conjuntas facilita la superación de las diferencias y contribuye al fortalecimiento de la convivencia.',
        imagen: require('@/assets/curso/tema5/18.png'),
        // leyendaImagen: 'Leyenda de la imagen',
      },
    ],
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass"></style>
